import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';
import { toast } from 'react-toastify';
import Breadcrumbs from '../CommonElements/Breadcrumbs';
import Table from '../CustomComponent/Tables/Table';
import { TableColumn } from 'react-data-table-component';
import { useUser } from '../Contexts/UserContext';
import { getAllClientsMeters } from '../Services/PortfolioService';
import { formatDate, sortByKey } from '../Utils';

export default function GroupMeterReport() {
    const [meters, setMeters] = useState<any>([]);

    const fetchMeters = async () => {
        try {
            const data: any[] = await getAllClientsMeters();
            // setMeters(sortByKey(data, 'name'));
            setMeters(data);
        } catch (error: any) {
            toast.error(error?.message || 'Failed to fetch meters');
        }
    };


    useEffect(() => {
        fetchMeters();
    }, []);

    const meterTableColumns: TableColumn<any>[] = [
        {
            name: "Client",
            cell: (row) => row.client?.name || '',
            sortable: false,
            center: false,
            width: '200px',
        },
        {
            name: "Property",
            cell: (row) => row.property.name,
            width: '200px',
            sortable: false,
            center: false,
        },
        {
            name: "Meter Name",
            selector: (row) => row.name,
            width: '200px',
            sortable: false,
            center: false,
        },
        {
            name: "Type",
            selector: (row) => row.meter_type,
            width: '120px',
            sortable: true,
            center: false,
            // color: 'orange'
        },
        {
            name: "Meter No.",
            selector: (row) => (
                <div>
                    <div>{row.meter_no_1 || ''}</div>
                    <div>{row.meter_no_2 || ''}</div>
                </div>
            ),
            // selector: (row) => row.site_id,
            width: '150px',
            sortable: true,
            center: false,
            // color: 'orange'
        },
        {
            name: "Utility",
            cell: (row) => row.utility?.name || '',
            sortable: false,
            center: false,
        },
        {
            name: "Supplier",
            cell: (row) => row.supplier?.name || '',
            sortable: false,
            center: false,
        },
        {
            name: "Data Collector",
            cell: (row) => row.data_collector || '',
            width: '120px',
            sortable: false,
            center: false,
        },
        {
            name: "Meter Operator",
            cell: (row) => row.meter_operator || '',
            width: '140px',
            sortable: false,
            center: false,
        },
        {
            name: "Status",
            cell: (row) => row.status ? row.status.charAt(0).toUpperCase() + row.status.slice(1) : '',
            sortable: false,
            center: true,
        },
        {
            name: 'Contract End date',
            cell: (row) => row.contract_end_date ? formatDate(row.contract_end_date) : '',
            width: '140px',
            sortable: false,
            center: false,
        },
    ];

    return (
        <>
            <Row>
                <Col md="8" className=''>
                    <Breadcrumbs pageTitle='Meter Report' />
                </Col>
            </Row>
            <Container fluid className='default-dashboard'>
                <Row>
                    <Col sm="12">
                        <Table title='Meter Report' tableColumns={meterTableColumns} data={meters} />
                    </Col>
                </Row>
            </Container>
        </>
    )
}